// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1cfi2","box":"WorkspacesBox_box__1FsKi","node":"WorkspacesBox_node__3sxot"};